module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride5"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph3"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_c('br', {
    staticClass: "calibre2"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph3"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("The main square of Campiglio was getting another dusting of light snow. Earlier, a Zamboni-like machine had pushed the night’s accumulation into high piles on two sides of the ")]), _c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("piazza")]), _c('span', {
    staticClass: "charoverride8"
  }, [_vm._v(", allowing the pensioners out for their morning exercise to stroll across it without trouble. The afternoon crowd was different—more mothers with carriages and small children, and even some tourists who for some reason had skipped the afternoon session on the slopes. The shops were open, but would not be doing much business until the late afternoon and evening when the mountain closed. Luca gestured Rick to stop, pointing to three little boys who had climbed to the top of one of the snowbanks. They were pushing chunks of snow off their little hill and watching them splatter over the pavement. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Look at the reactions of those men on the bench,” said Luca. Four men in their seventies sat watching the boys’ antics. “The two on the left, who are frowning, they don’t have any grandchildren. But not the other two men, they are loving it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick studied the bench. “Perhaps the two grumpy ones are relatives of the men who sweep the ")]), _c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("piazza")]), _c('span', {
    staticClass: "charoverride8"
  }, [_vm._v(". Or maybe they had the job themselves before they retired.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“When I retire, I will prefer watching children.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“You’re too young to be thinking about retirement, aren’t you, Luca?” They walked out of the square onto Campiglio’s main street, following the directions given them at the local police station. Luca had politely turned down the offer of the sergeant to accompany them to the apartment of the missing man’s sister. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“It is never too early to think about choices in life, my American friend, no matter how distant they may seem to be. Life is like riding in a car on the ")]), _c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("autostrada")]), _c('span', {
    staticClass: "charoverride8"
  }, [_vm._v(". You vaguely make out something very far off, and before you realize it…zoom, it is past you. You must always be watching, enjoying what is around you, asking questions. Like that balcony up there.” Most of the buildings on the main street had shops at street level, apartments in the upper stories, most with balconies. Inspector Albani was looking at one whose flower boxes, despite the season, were filled with healthy red geraniums. “The person living in that apartment has taken loving care of those flowers, perhaps covering them at night to avoid freezing, or even bringing them inside. The contrast with the other apartments on the floor is striking. What would cause someone to go to such trouble? The desire to show up the neighbors? Or something more noble, like a vow to continue to care for the flowers after the death of a spouse who in life took great joy in them? There is a story there, either an uplifting one or something more banal.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick was starting to understand what Flavio meant about getting tired around Luca. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“I am curious, Riccardo, about you and Flavio, the chance meeting at the university which has turned into a strong friendship. He was immersed in a foreign culture, struggled, but was thrown a lifeline by someone who by chance had lived in two cultures himself. The story fascinates me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Everything seems to fascinate you, Luca.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("The policeman laughed. “You are right. But you two are so different. You seem very relaxed and cheerful. Flavio, he’s…”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“He’s not relaxed and cheerful. True. But now it’s my turn for the analysis. I think you know very well how we could have become friends, since you went through the same process after you two met during that embezzlement investigation. He came to trust you, and you eventually got through Flavio’s armor and found that he could be a loyal friend. You learned that he would, as we say in America, give you the shirt off his back. And now you want to see if my experience was the same as yours. Am I right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Luca’s grin almost ran the width of his round face. “I am impressed by your intuition, Riccardo. You will be of great help in this investigation, and not just by allowing me to bounce my theories off a fellow Roman.” Rick threw up his hands defensively. “Yes, yes,” responded Luca, “you are not a Romano in the usual sense. But, regardless, your uncle is right in trying to get you into police work full-time rather than occasionally helping out policemen like me.” He brushed snow off his thick black hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Won’t happen, Luca. Where’s your hat?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“How embarrassing. I left Trento this morning in such a rush I forgot to pack it. Mine would not be as stylish as yours, though.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick touched his fingers to the brim of his Borsalino. He’d admired it in the window of a hat shop near Piazza Navona for weeks before the cooler weather in Rome finally provided a justification for the purchase. “Unless you can find this guy quickly, Luca, you’ll have to get one here. You don’t want to be catching a head cold.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“You sound like my wife.” He looked at a piece of paper he’d pulled from his coat. “The building should be just ahead. There it is, Number 381. Apartment 4A.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("The entrance to the residential floors was centered between two shops. A shoe store was on the left, its ")]), _c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("vetrina")]), _c('span', {
    staticClass: "charoverride8"
  }, [_vm._v(" shelves filled with thick-soled boots and furry after-ski footwear. Sweet smells escaped through the glass doors of the bakery on the other side. Cookies and small cakes were artistically stacked to lure the passing public, but after his hearty lunch at the hotel Rick was not tempted. The door to the apartment entrance was open and the two men walked into a small hallway decorated with marble and glass. Not luxurious, but certainly not shabby. They got into the elevator and took it to the top floor where they found apartment A and rang the bell.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Money was what came to mind when Rick saw the woman who answered the door. Who was it who said you can never be too rich or too thin? Catherine Taylor’s outfit was casual but chic: black corduroy slacks over brown leather boots, a white cashmere sweater, a single pearl hanging from a gold pendant around her neck. The blond hair was pulled back and held in place with a thin wine-colored scarf, revealing small gold hoops in her ears. Makeup was minimal, but she didn’t need much after what nature had bestowed. Despite her age, which Rick guessed to be about twenty-five, she did not appear to be awed to be in the presence of the police. Whether she had summoned them or been stopped by them in the past remained to be seen. What she did show on her face was surprise that the policeman—and it was clear from Luca’s suit and overcoat who was the policeman—was accompanied by someone in the more informal attire of the town, including—strangely enough—cowboy boots. And that person was only a few years older than she was, and good-looking. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“I was expecting only one person.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Luca extended his hand to the woman and stepped slowly into English. “I am Inspector Albani, from Trento. My English, it is not good. I have brought Signor Montoya, who will give a help.” He grinned at her and then at Rick.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“I’m Rick Montoya, Miss Taylor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Montoya. That sounds Mexican.” She concentrated on Rick as if the policeman, after making his initial speech, had suddenly disappeared. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“New Mexican, actually.” Rick wondered what other warm and welcoming phrases would emerge from this lovely mouth. “Montoyas have been living there for about three hundred years. May we come in?” Luca continued to smile, not getting any of what Rick had said.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Oh, of course. Sorry.” She stood back and gestured toward the room which opened off the small entrance way, giving Rick a whiff of a vaguely familiar perfume. The living room had the kind of furniture which would be expected in a Dolomite ski resort rental: wood and more wood. Had it been Montana, there would have been a few antlers hanging somewhere, but here the wall decorations were local tourism posters. On a table in one corner sat a large wood carving of a deer or elk, he wasn’t sure which. Rick’s eyes were drawn to the large window and its view of the eastern side of the valley. He could see a few rays of sun hitting the ")]), _c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("piste")]), _c('span', {
    staticClass: "charoverride8"
  }, [_vm._v(", where he would have been had he gone skiing with Flavio. Getting a tan was one of the primary reasons Italians went to the mountains, so the east-slope trails were popular with the afternoon skiers. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Without being asked, the two men pulled off their overcoats and folded them over a lone wooden chair near the door. Catherine Taylor took a seat in a cushioned chair with arms of roughly hewn logs, and motioned her visitors to the matching sofa that faced her. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("The policeman took a notebook and pen from his suit pocket and spoke in Italian. “Riccardo, if you could ask her about the circumstances of her brother’s disappearance? When it was, what he did in the days before, that kind of thing.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Miss Taylor,” said Rick in English, “could you—?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Please call me Cat, everyone does.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("So the snow queen wants to melt, he thought. “Fine, Cat. And please call me Rick. If you could tell us exactly what happened, on a time line, to get things started. I will give the inspector a running translation as you talk.” He inclined his head toward the policeman who sat with pen poised, and when she started to speak, Rick translated in a low voice, as he had done countless times in his work. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“My brother and I have been here for five days. That is, here in Campiglio. I was in Milan for one night before we came up here. He rents this apartment from someone he knows. Well, we both know him, from Milan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“So you have been to Italy before.” Rick translated his question for the policeman before turning back to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Oh, yes. Cam—nobody calls him Cameron except our parents—Cam has been living in Milan for almost two years, and I’ve visited him a few times.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Cam and Cat, thought Rick. Cute. “It sounds like you are very close to your brother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Her answer was not what he expected. “I don’t think you could characterize our relationship as close. Saying that my older brother has always bullied me would be too strong, but he has tried always to order me around, like he knows what’s best for me.” Luca looked up from his pad for the first time to see the look on her face, one which matched her comment. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“My older sister used to treat me like that,” said Rick, hoping to lighten things up.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“This was more than the usual brother-sister rivalry, Rick.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Yet you came here for various visits.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("She leaned back in the chair and carefully crossed her legs, the slacks tightening over her knee. “He’s my brother,” she said, as if that explained everything. “And, I just went through a difficult divorce, so what better way to get away from problems than jump on a plane for Italy? Cam had told me not to marry the guy in the first place, but at least he’s been decent enough not to keep reminding me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“And what has been your routine since you got to Campiglio?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“What you would expect on a ski holiday, though for Cam it’s been a combination of business and pleasure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“How so?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Cam was meeting with someone involved in real estate regarding a possible loan from the bank where he works.” This got another look from the policeman. “He didn’t give me any details, of course.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Well,” said Rick, “it’s a good way to write off some of the expenses for the trip.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("For the first time Cat Taylor laughed, and it was not endearing. “Let me tell you something about my brother, Rick. He attended parochial school and then went on to fulfill his dream of graduating from Notre Dame. He stayed on in South Bend to study international business. One of the basic precepts drummed into his head in business school was the importance of ethics. He takes the morality of business dealings very seriously. So, in response to what you said, I know for certain that he would never go on a ski trip and write it off as business expense because of some short meeting with someone. Even if the bank allowed it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick was impressed. “He sounds like a very—”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("She raised her hand to interrupt. “Ah, but unfortunately this high moral posturing only counts in his work. His personal life is a different story.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("By now the policeman was concentrating on her face. His pen rested on the pad. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Are you talking about the way he treats you?” Rick asked. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“The way he treats me is of no real importance, I’ve been able to defend myself since I was in grade school.” The two men continued to stare at her, waiting. “Let me put it this way. When this job in his bank’s Milan office came up, he jumped at it. After all, he had done a semester abroad in Rome as an undergraduate at Notre Dame and spoke passable Italian. But the real reason he was so enthusiastic was that it would get him out of town, way out of town, far from not just one but two women.” She laid her right arm carefully over the back of the chair and smirked. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick was intrigued. Why is this woman talking this way about her missing brother? Apparently Luca had the same thought, and he spoke softly into the ear of his trusted interpreter who listened and then turned back to Catherine Taylor. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Cat, we seem to have gotten off track. Can we get into the details of what your brother did since you arrived here? He’s the one the inspector is here to find.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Of course.” She gazed at the ceiling to gather her thoughts and Luca once again readied his pen and pad. “We drove up Wednesday from Milan after lunch and got here just as it was getting dark. There was no food in the apartment so we went out to a restaurant for dinner.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Just the two of you?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Yes. I wasn’t very hungry, and was still tired from the flight since I’d arrived that morning. I’m not very good with jet lag. I’m still not sleeping through the night and need a nap in the late afternoon. Cam naturally tries to keep me going all day, says it’s the only way to beat it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick tried to keep her on topic. “The next day?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Thursday, we skied in the morning and had some lunch on the mountain. After eating we skied down, I stayed in, and Cam went to his meeting. Before you came I was trying to recall the man’s name since I knew you’d ask, and all I can remember is that Cam said his name meant pomegranate.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Melograno.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“That’s it. Funny that people would be called pomegranate. Although I had a friend at boarding school whose last name was Pear.” She stopped and looked at Rick. “You didn’t translate what I just said for the inspector.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“No, I didn’t. What about Thursday night?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Cam had picked up some food after his meeting in the afternoon so we ate here. Then he went out and I read a book and went to sleep early. Of course I woke up in the middle of the night. I told you I have a problem—”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“With jet lag. Yes, you did. Do you know where your brother went that night?")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“He went to a bar, but I don’t know which one. Since he’s spent a lot of time up here in the last year he’s become familiar with the nightlife, such as it is, in this town.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Did he mention who he talked to, or anything about what happened in the bar?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("A satisfied smile came to her face. “Normally, he wouldn’t tell me anything, but the next morning I found out that he’d met a woman in the bar, and they’d hit it off quite well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick was about to ask if the woman was in the apartment when she got up, but decided against it. “How was it you found out?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“When we went skiing we ran into her. Or she spotted Cam and ran into us. I don’t understand Italian, of course, but I could tell by her tone of voice, and his, that there was something there. When he introduced me to her he said they’d been together the night before.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“What was her name?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“That, I remember. Gina Cortese. The name fits her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick wasn’t sure what she meant by the comment, and from Luca’s expression, he didn’t either, despite a good translation. “So he picked up this Gina Cortese in the bar.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“No, I didn’t mean to give that impression. He already knew her from previous visits here. In fact he said he’d met her the first summer he came up to Campiglio for the hiking, a year and a half ago. That was when he decided to rent a place. I doubt if Cam’s latest girlfriend in Milan knows about her, but that’s typical of my brother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Do you know if this woman is from here or only comes for holiday?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“She’s from here, she has to be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Why do you say that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“She’s a ski instructor, complete with the blue ski coat they all wear, with the round patch. I took some lessons last year and my instructor wore the same outfit. Her class was waiting while she and Cam made goo-goo eyes at each other.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("It took Rick a couple seconds to come up with an Italian equivalent for “goo-goo eyes,” but Luca didn’t appear to notice the delay. “So you skied again that morning. And the rest of Friday?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“I stayed in for the afternoon, after eating lunch here, and Cam went back up. That night he had dinner with Miss Cortese.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“You ate here in the apartment?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“I thought you were only interested in my brother’s movements.” Rick shrugged. “Well, I went to a restaurant with Daniele. Daniele Lotti, he owns this apartment and the one across the hall, and he arrived in town Friday afternoon. Cam knows him from Milan, which is how he came to rent this apartment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“So a friend from Milan. Also a banker?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“No, he works for a drug company. Cam met him through the American Chamber of Commerce. Daniele studied in the States.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Notre Dame business school?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("She rolled her eyes. “No, thank goodness.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“So you’d met him before this trip.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Yes, in Milan and up here. Shouldn’t we get back to talking about my brother?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick and Luca noted her tone. “Certainly,” said Rick. “Did you see your brother that night?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Yes, I was still up when he came in. He asked me if I was going to ski the next morning and I said I would pass and see him at lunch. I needed a morning off. ”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“So he went out skiing the next morning.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“I have to assume so. His ski clothes are gone from his closet, and his skis, boots, and poles are not in the building’s storage room in the basement. But his scuffs, which he wears down the elevator, are in his boot locker down there. So he put on his ski boots and walked out to the street carrying his skis, like we always do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Luca said something to Rick while she watched. He translated. “The inspector wonders why you waited until Sunday afternoon to notify the authorities.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“I expected you to ask that,” she said, shifting in her chair. “I thought my brother had run into that woman again and they’d decided to spend the day together. And when it got late in the evening, I assumed one thing had led to another.” Rick nodded and Luca kept his eyes on the small pad, now filling with his notes. “But when I got up Sunday morning and he wasn’t here, I began to get worried. In the afternoon I called the embassy in Milan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Consulate,” Rick corrected. It was a pet peeve.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Whatever. Cam had given me their number on my first trip to Milan last year, in case I needed it in an emergency. Since it’s the weekend, I got the duty officer, and he called the police.” She glanced at Luca. “And now you are here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Please tell her, Riccardo, that—” Rick held up his hand and leaned forward toward Cat, indicating that he was going to be translating in the other direction. “Tell her that we ordered a search of the mountain by the ski patrol. They had not found anyone yesterday evening on their final run, but they did another one this morning, with special care, and came up with nothing. If she can provide me a photograph of her brother, I will give it to the local policemen, who will be glad to be doing something other than issue parking citations. We will attempt to find someone who remembers seeing him yesterday morning.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("She listened to Rick’s translation and spoke. “You must find my brother,” she said with more passion than she’d shown since their arrival. Luca noticed it, but she didn’t see the faint smile on the policeman’s face, since her attention was on Rick alone. “Let me get you a photograph. I have one from my last trip here.” She jumped to her feet. “It’s perfect since he’s wearing the same ski clothes he had on yesterday morning.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("She walked quickly out of the room and Rick noticed again that her slacks were a perfect fit. He looked at Luca whose smile had widened. Rick was about to speak when Cat returned with a picture inside a cardboard frame and passed it to Rick. Luca leaned to get a look while she returned to her chair.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("The photograph was taken by one of the commercial photographers who stationed themselves on the mountain at places with the most picturesque background. It showed Cat and her brother leaning on their ski poles, a whitened peak behind them. He wore black ski pants and black boots, a light blue ski coat, and a dark blue baseball cap with the gold letters ND on the front. Sunglasses hung from leashes, covering the top of a red sweater visible above the zipper of the coat. Around his neck a blue print bandana was tied, almost in the style of the Old West. Cat wore a one-piece puffy suit, blue with a matching belt, and white ski boots. Her goggles were pushed up to the front of a knit cap that covered most of her blond hair. The resemblance was more than clear. Both siblings had the same cheekbones and nose, and they wore similar smiles, no doubt perfected by posing for countless family albums and school yearbooks. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“I can’t make out your brother’s hair,” Rick asked. “Is he blond like you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“His hair is darker, almost brown.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("It was Luca’s turn to ask a question. “His skis, they look silver, but is that just the snow on them?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“They are silver,” she answered after Rick translated. “He ")]), _c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("special")]), _c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("-ordered them from the Kolmartz factory in Austria. Those skis and the Notre Dame cap are his most prized possessions.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Do you have Kolmartz skis too?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Heavens, no. I always rent skis with Bruno, whose shop is just across the street.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“I think that’s the place where I rented my skis,” said Rick. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Did her brother have his cell phone with him?” Rick translated the question.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“He usually carries it when he skies, even though much of the mountain is a dead zone. Just habit. The phone is not here in the apartment, so I assume he has it with him. Of course he hasn’t answered it when I’ve tried to call.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“But he could have called you,” said the policeman through Rick.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("She turned to Rick. “Doesn’t the inspector understand that Cam not calling just could be one reason I notified the consulate? Is he understanding what’s going on here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick decided not to translate, instead asking his own question. “Did he always ski on the same trails in the morning?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“When I’m not with him he usually gets on the chairlift right behind the apartment, since the runs up there are too difficult for me. He’s a very good skier. When I’m with him, we walk to the gondola just up the hill from here. The trails there are more my speed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Luca said something in Rick’s ear while she watched. When finished, Rick asked, “Cat, do you have his office phone, and the name of his supervisor at the bank?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Didn’t I give you that? I think there are some of his cards in this desk.” She went to a desk set against one wall, bare save for a laptop computer and a small lamp. From the drawer she pulled out a card which she passed to Rick before sitting down again. “I don’t know anyone who works there. Cam has decided I’m not important enough to be introduced to his fellow bankers.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Thank you, Cat,” Rick said, for lack of any other way to react to her comment. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick glanced at Luca, silently asking if there were more questions. The policeman shook his head. “We will talk with her again, Rick. For now we have what we want.” Rick noticed the use of “we” instead of “I.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("They got to their feet. “Cat,” said Rick, “thanks for your time. I can assure you that the inspector will let you know as soon as he has something about your brother.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("She looked up at them for a few moments before rising from the chair. “I’m glad that you are helping him, Rick.” It was a strange thing to say, Rick thought. “Can you give me your cell phone in case I hear anything myself? I can’t call ")]), _c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("him")]), _c('span', {
    staticClass: "charoverride8"
  }, [_vm._v(" since he doesn’t speak English.” She said it without looking at Luca. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“Of course.” Rick pulled out his wallet and passed her a business card. “My cell is on there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("She studied the card and looked at Rick, smiling. “Translation services. And in Rome. I thought you lived up here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("“No, I’m here on holiday and got roped into helping the inspector. Which I was glad to do, of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("She stuffed the card into her front pants pocket and took Rick’s arm. “Let me see you to the door.” Luca remained invisible until the two men had slipped on their coats and she was obliged to shake the policeman’s hand. “Thank you, Inspector,” she said before turning back to Rick. “I know you will find my brother, Rick. The inspector has my number, call me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("Rick waited for her to add “when you find my brother,” but she didn’t.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61746195","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Chapter_3.vue
// module id = 81
// module chunks = 0